(function () {
  const sections = document.querySelectorAll(".wl-overlay-content");
  if (!sections.length) return;

  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));

  sections.forEach((section) => {
    const bg = section.querySelector(".wl-overlay-content__bg");
    if (!bg) return; // only when bg_paralax is enabled for this block

    const left = bg.querySelector(".wl-overlay-content__slice.is-left");
    const mid = bg.querySelector(".wl-overlay-content__slice.is-mid");
    const right = bg.querySelector(".wl-overlay-content__slice.is-right");
    if (!left || !mid || !right) return;

    let active = false;
    let rafId = null;

    // Tune intensity (px). You can also read from a data- attribute if you want.
    const maxShift = 150;

    const update = () => {
      rafId = null;

      const rect = section.getBoundingClientRect();
      const vh = window.innerHeight || document.documentElement.clientHeight;

      // progress 0..1 as section travels through viewport
      const total = rect.height + vh;
      const t = clamp((vh - rect.top) / total, 0, 1);

      // convert to -maxShift..+maxShift
      const shift = (t - 0.5) * 2 * maxShift;
      const midShift = (t - 0.5) * 4 * maxShift;

      // left/right up, mid down
      left.style.transform = `translate3d(0, ${-shift}px, 0)`;
      right.style.transform = `translate3d(0, ${-shift}px, 0)`;
      mid.style.transform = `translate3d(0, ${midShift}px, 0)`;
    };

    const onScroll = () => {
      if (!active) return;
      if (rafId) return;
      rafId = requestAnimationFrame(update);
    };

    const io = new IntersectionObserver(
      (entries) => {
        const isIntersecting = entries.some((e) => e.isIntersecting);
        active = isIntersecting;

        if (active) {
          update();
          window.addEventListener("scroll", onScroll, { passive: true });
          window.addEventListener("resize", onScroll, { passive: true });
        } else {
          window.removeEventListener("scroll", onScroll);
          window.removeEventListener("resize", onScroll);
        }
      },
      { threshold: 0, rootMargin: "200px" }
    );

    io.observe(section);
  });
})();
